import React from 'react';
import { Col, Row, Image } from '@thd-olt-component-react/core-ui';
import { generateImageSource } from '../../../utils/generateImageSource';
import './JobPostingIntro.scss';

export const JobPostingIntro = () => {

  return (
    <Row>
      <Col xs={6} sm={4}>
        <Image
          className="job-posting-image-intro__desktop"
          src={generateImageSource('/images/v1/path-to-pro/panel-1-Post-Jobs@2x.png')}
          alt="job posting 1"
        />
        <Image
          className="job-posting-image-intro__mobile"
          src={generateImageSource('/images/v1/path-to-pro/panel-1-Mobile@2X.png')}
          alt="job posting 1"
        />
      </Col>
      <Col xs={6} sm={4}>
        <Image
          className="job-posting-image-intro__desktop"
          src={generateImageSource('/images/v1/path-to-pro/panel-2-Review-Applicants@2x.png')}
          alt="job posting 2"
        />
        <Image
          className="job-posting-image-intro__mobile"
          src={generateImageSource('/images/v1/path-to-pro/panel-2-Mobile@2X.png')}
          alt="job posting 2"
        />
      </Col>
      <Col xs={6} sm={4}>
        <Image
          className="job-posting-image-intro__desktop"
          src={generateImageSource('/images/v1/path-to-pro/panel-3-Hire_Skilled_Labor@2x_2.png')}
          alt="job posting 3"
        />
        <Image
          className="job-posting-image-intro__mobile"
          src={generateImageSource('/images/v1/path-to-pro/panel_3-Mobile@2X_2.png')}
          alt="job posting 3"
        />
      </Col>
    </Row>
  );
};
